import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ProfissionalInserirRoutingModule } from "./profissional-inserir-routing.module";
import { ProfissionalInserirComponent } from "./profissional-inserir.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { InputSwitchModule } from "primeng/inputswitch";
import { DialogModule } from "primeng/dialog";
import { TabViewModule } from "primeng/tabview";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TableModule } from "primeng/table";
import { InputNumberModule } from "primeng/inputnumber";


@NgModule({
    imports: [
        CommonModule,            
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        InputTextareaModule,
        ProfissionalInserirRoutingModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule,
        DialogModule,
        ConfirmDialogModule,
        TableModule
    ],
    providers: [ConfirmationService],
    declarations: [ProfissionalInserirComponent]
})
export class ProfissionalInserirModule { }
